import AsyncStorage from '@react-native-async-storage/async-storage';

export const save = async (key, value) => {
  await AsyncStorage.setItem(key, JSON.stringify(value));
};

export const get = async (key) => JSON.parse(await AsyncStorage.getItem(key, () => {}));
